import { Auth } from "aws-amplify";
import { APIEndpoints } from "./services/api/config";

const appConfig = {
  //Auth is the same as before
  Auth: {
    region: process.env.REACT_APP_USERPOOL_REGION,
    userPoolId: process.env.REACT_APP_USERPOOL_ID,
    userPoolWebClientId: process.env.REACT_APP_USERPOOL_CLIENT,
    authenticationFlowType: "USER_SRP_AUTH",
  },
  AgGrid: {
    license: process.env.REACT_APP_AGGRID_LICENSE,
  },
  StatsApp: {
    baseUrl: process.env.REACT_APP_API_STATS_DASHBOARD_HOST,
  },
  Settings: {
    isEnableEncrypt: process.env.REACT_APP_ENABLE_ENCRYPT  === "true"
  },
  API: {
    endpoints: [
      {
        name: APIEndpoints.private,
        // endpoint: "http://0.0.0.0:8001",
        // endpoint: "http://localhost:8001",
        endpoint: process.env.REACT_APP_API_CORE_HOST,
        custom_header: async () => {
          return {
            Authorization: `Bearer ${(await Auth.currentSession())
              .getAccessToken()
              .getJwtToken()}`,
          };
        },
      },
      {
        name: APIEndpoints.public,
        // endpoint: "http://0.0.0.0:8001",
        endpoint: process.env.REACT_APP_API_CORE_HOST,
      },
    ],
  },
};

export default appConfig;
